//==========import components===============
import Button from 'components/common/Button';
import TitleSection from './TitleSection';
import { AiFillRightCircle } from 'react-icons/ai';
const titleDetail = {
  joinEventTitle: "JOIN WORLD's BEST EVENT ORGANIZATION",
  lowerTitle: 'Start learning by registering for free',
};

const JoinEventOrganizer = ({ bgColor }) => {
  const handleSubmit = (event) => {
    event.preventDefault();
  };
  return (
    <section
      className={`joinEventSec DBlock py-10  px-6 sm:px-10 ${
        bgColor ? bgColor : 'bg-eventLightPink'
      }`}>
      <div className='max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-6 relative z-1 '>
        <img
          className='w-full'
          src='/assets/images/common/joinOrganization.png'
          alt='evmImg'
        />
        <div className='md:pt-16 pt-4 flex flex-col'>
          <TitleSection titleDetail={titleDetail} />
          <form
            onSubmit={handleSubmit}
            className='grid grid-cols-1 lg:grid-cols-2 gap-6'>
            <label className='relative w-64 md:w-auto flex items-center'>
              <input
                className='border w-full text-sm border-gray-300 rounded-full py-2.5 px-3'
                type='email'
                name='email'
                placeholder='johndoe@shuffle.dev'
                required
              />
              <button type='submit' className='absolute right-2 top-2'>
                <AiFillRightCircle size={25} fill='#F6BC4E' />
              </button>
            </label>
            <div className='flex justify-center items-center'>
              <Button url='/contact-us' title='Contact Us' />
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default JoinEventOrganizer;
